// extracted by mini-css-extract-plugin
export default {"foto":"FotoA_foto__n4hoE"};